/**
 * Applies the localized contextual label supplied by the CTA's parent component.
 *
 * @param {HTMLElement} button
 */
export function syncCtaAriaLabel(button) {
	const scope = button.closest('[data-lvz-cta-title]');
	if (!scope) {
		return;
	}

	const title = (scope.getAttribute('data-lvz-cta-title') || '').trim();
	const prefix = (scope.getAttribute('data-lvz-cta-aria-prefix') || '').trim();
	if (!title || !prefix) {
		return;
	}

	button.setAttribute('aria-label', `${prefix} ${title}`);
}
